export default () => {
    return {
        FullScreen (state, isFullScreen) {
            state.isFullScreen = isFullScreen
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/mutations/mutationsHome.js